<template>
  <div class="px-4">
    <TsRow append-class="justify-between pt-4 pb-2">
      <TsColumn class="max-w-max">
        <TsRow append-class="items-center">
          <TsIcon
            @click="handleBackNavigation"
            name="iconamoon:arrow-left-2-duotone"
            size="1.75rem"
            class="cursor-pointer mr-2 text-black"
          />
          <TsTypography
            as="h4"
            appendClass="mb-0"
            :text="selectedData && selectedData.taxonomy ? getLocaleName(selectedData.taxonomy) : 'Explore Categories'"
          />
        </TsRow>
      </TsColumn>
      <TsColumn append-class="max-w-max">
        <TsTypography
            @click="handleCategoryNavigation"
            append-class="text-info text-base underline cursor-pointer hover:no-underline"
        >View All</TsTypography
        >
      </TsColumn>
    </TsRow>
    <TsDivider appendClass="my-0"/>

    <div v-if="menuStore.categories_state.status === 'success'" class="my-2">
    <TsRow
      v-for="tile in selectedData?.children || menuStore?.categories?.data"
      :id="tile?.taxonomy?.id"
      append-class="text-gray-500 cursor-pointer py-1"
      @click="handleSelectedCategory(tile)"
    >
      <TsColumn class="is-11">
        <TsRow append-class="items-center gap-2 m-0">
          <TsIcon
            v-if="Object.keys(categoryIcons).includes(tile.taxonomy.name)"
            :name="categoryIcons[tile.taxonomy.name]"
            size="20"
            class="size-5"
          />
          <TsTypography
              v-if="tile.children.length"
            as="p"
            append-class="mb-0 font-semibold text-base text-gray-500"
            :text="getLocaleName(tile.taxonomy)"
            @click.stop="
              handleSelectedCategory(tile)
            "
          />
          <TsTypography
              v-else
              as="p"
              append-class="mb-0 font-semibold text-base text-gray-500"
              :text="getLocaleName(tile.taxonomy)"
              @click.prevent="
              handleSubCategoryClick(selectedData.taxonomy.name,tile?.taxonomy?.name, tile?.taxonomy?.id)
            "
          />
        </TsRow>
      </TsColumn>
      <TsColumn class="max-w-max">
        <TsIcon
          v-if="tile?.children?.length"
          name="lucide:chevron-right"
          size="22"
          class="size-5"
        />
      </TsColumn>
    </TsRow>
    </div>
    <TsCategoriesTransition v-else />
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import { categoryIcons } from "~/assets/constants/ui";
const {locale, locales} = useI18n();

const TsCategoriesTransition = defineAsyncComponent(
    () => import('~/components/organisms/TsCategoriesTransition.vue')
);

const emit = defineEmits(["back", "redirect"]);
const selectedData = ref();
const menuStore = useMenuStore();
const localePath = useLocalePath();

 
function handleSelectedCategory(texonomyData: any) {
  if (!texonomyData?.children?.length) return;
  selectedData.value = texonomyData;
}

const handleCategoryNavigation = async () => {
  emit("redirect");
  if (!selectedData.value) await navigateTo(localePath("/categories"));
  else
    handleCategoryClick(
      selectedData.value.taxonomy?.name,
      selectedData.value.taxonomy?.id
    );
};

function handleBackNavigation() {
  selectedData.value ? (selectedData.value = undefined) : emit("back");
}

const handleCategoryClick = async (categoryName: string, categoryid: number) => {
 await navigateTo(localePath(getCategorySlug(categoryName, categoryid)));
};

const handleSubCategoryClick = async (
  categoryName: string,
  subCategoryName: string,
  subCategoryId: number
) => {
 await navigateTo(localePath(getSubCategorySlug(categoryName, subCategoryName, subCategoryId)));
  emit("redirect");
};

function getLocaleName(taxonomy) {

  return getTaxonomyLocaleName(taxonomy,locale.value,locales.value);

}
</script>
